import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export const init = () => {
  const header = document.querySelector(".header");
  if (!header) return;

  let isHidden = false;

  ScrollTrigger.create({
    start: "top top",
    end: 99999,
    onUpdate: (self) => {
      const scrollY = self.scroll();

      // Si estamos arriba del todo, siempre mostrar
      if (scrollY < 60) {
        if (isHidden) {
          gsap.to(header, {
            yPercent: 0,
            duration: 0.3,
            ease: "power2.out",
            overwrite: true,
          });
          isHidden = false;
        }
        return;
      }

      // Scroll hacia abajo -> Ocultar
      if (self.direction === 1 && !isHidden) {
        gsap.to(header, {
          yPercent: -100,
          duration: 0.3,
          ease: "power2.out",
          overwrite: true,
        });
        isHidden = true;
      }
      // Scroll hacia arriba -> Mostrar
      else if (self.direction === -1 && isHidden) {
        gsap.to(header, {
          yPercent: 0,
          duration: 0.3,
          ease: "power2.out",
          overwrite: true,
        });
        isHidden = false;
      }
    },
  });
};
